import React from "react";
import { Link } from "react-router-dom";

const NearbyTruckersModal = ({ show, onClose, loading, contractors = [], center }) => {
  if (!show) return null;

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-custom">
        <div className="modal-header-custom">
          <h5 style={{ margin: 0 }}>
            Nearby Truck Companies{/*center ? `(within ${center.meters || 2000}m)` : ""*/}
          </h5>
          <button className="btn btn-sm btn-danger" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="modal-body-custom">
          {loading ? (
            <p>Loading nearby contractors...</p>
          ) : contractors.length === 0 ? (
            <p>No nearby contractors found.</p>
          ) : (
            <div className="list-group">
              {contractors.map((c) => (
                <div key={c.id} className="list-group-item">
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                    <div>
                      <div style={{ fontWeight: 600 }}>
                        {c.company_name || `${c.first_name || ""} ${c.last_name || ""}`}
                      </div>
                      <div style={{ fontSize: 13 }}>
                        {c.email ? <span>{c.email}</span> : null}
                        {c.phone_number ? <span> • {c.phone_number}</span> : null}
                      </div>

                      {/* Optional: show latest post details from contractor */}
                      {c.post_id ? (
                        <div style={{ fontSize: 13, marginTop: 6 }}>
                          <div><b>Latest Post:</b> {c.post_project_name || "-"}</div>
                          <div><b>Address:</b> {c.post_address || "-"}</div>
                        </div>
                      ) : null}

                      <Link
                        className="button customButton01"
                        to={`/detail/${c.id}`}
                        style={{ marginTop: 8, display: "inline-block" }}
                      >
                        View Full Detail
                      </Link>
                    </div>

                    <div style={{ textAlign: "right", minWidth: 90 }}>
                      <div style={{ fontWeight: 600 }}>
                        {Number(c.distance || 0).toFixed(0)} m
                      </div>
                      <div style={{ fontSize: 12, opacity: 0.8 }}>away</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* basic styles (you can move to css file) */}
      <style>{`
        .modal-backdrop-custom{
          position: fixed; inset: 0;
          background: rgba(0,0,0,.5);
          z-index: 999999;
          display:flex; align-items:center; justify-content:center;
          padding: 20px;
        }
        .modal-custom{
          width: 720px; max-width: 95vw;
          background: #fff;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 15px 40px rgba(0,0,0,.35);
        }
        .modal-header-custom{
          display:flex; align-items:center; justify-content:space-between;
          padding: 12px 16px;
          background: #f7f7f7;
          border-bottom: 1px solid #eee;
        }
        .modal-body-custom{
          padding: 16px;
          max-height: 70vh;
          overflow: auto;
        }
      `}</style>
    </div>
  );
};

export default NearbyTruckersModal;
